import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root'
})
export class FormDataService {
  private formDataSubject = new BehaviorSubject<any>(null);
  private signatureSubject = new BehaviorSubject<string | null>(null);

  formData$ = this.formDataSubject.asObservable();
  signature$ = this.signatureSubject.asObservable();

  constructor(private http: HttpClient) { }

  validate_phone_number(phone: string): Observable<any> {
    return this.http.get(`https://api.wavix.com/v1/validation?appid=${environment.wavix_api_id}&type=format&phone_number=${phone}`);
  }

  saveFormData(data: any) {
    this.formDataSubject.next(data);
  }

  saveSignature(signature: string) {
    this.signatureSubject.next(signature);
  }

  getSignature(): string | null {
    return this.signatureSubject.getValue();
  }

  clearData() {
    this.formDataSubject.next(null);
    this.signatureSubject.next(null);
  }
}